import { Component, Output, Input } from "@angular/core";
import * as _ from "lodash";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

export interface SignedDocumentArchiveResponse {
  remarks: string;
}

@Component({
  selector: "app-signed-document-archive-modal",
  templateUrl: "./signed-document-archive-modal.component.html",
  styleUrls: ["./signed-document-archive-modal.component.scss"],
})
export class SignedDocumentArchiveModalComponent {
  @Output()
  save: Subject<SignedDocumentArchiveResponse> = new Subject<SignedDocumentArchiveResponse>();

  @Input()
  remarks: string;

  constructor(private readonly activeModal: NgbActiveModal) {}

  onClose() {
    this.activeModal.dismiss("Cross click");
  }

  get canSave() {
    return !!this.remarks;
  }

  onSave() {
    this.save.next({ ...this });
    this.activeModal.close();
  }
}
